const getters = {
  getEmployments: state => state.employments,
  getEmployment: state => state.employment

}


export default getters